// extracted by mini-css-extract-plugin
export default {"raceSelector":"MultiLegTab_raceSelector__lG-s6","raceSelectorButton":"MultiLegTab_raceSelectorButton__A5N-w","btnChild":"MultiLegTab_btnChild__A7r3t"};